import { FC } from "react";
import { SelectLabel } from "./SelectLabel";
import { Select } from "shared/components";
import FailedIcon from "shared/icons/status-icons/fail-icon.svg?react";

const importanceOptions = [
  {
    value: 1,
    label: (
      <SelectLabel
        title="Low"
        icon={
          <div className="flex h-5 w-5 items-center justify-center rounded bg-success-600">
            <p className="text-sm font-bold text-background-1000">1</p>
          </div>
        }
      />
    )
  },
  {
    value: 2,
    label: (
      <SelectLabel
        title="Moderate"
        icon={
          <div className="flex h-5 w-5 items-center justify-center rounded bg-warning-500">
            <p className="text-sm font-bold text-background-1000">2</p>
          </div>
        }
      />
    )
  },
  {
    value: 3,
    label: (
      <SelectLabel
        title="High"
        icon={
          <div className="flex h-5 w-5 items-center justify-center rounded bg-danger-500">
            <p className="text-sm font-bold text-background-1000">3</p>
          </div>
        }
      />
    )
  },
  {
    value: 0,
    label: (
      <SelectLabel
        title="Decline if fail"
        icon={<FailedIcon className="w-4 shrink-0 text-danger-500" />}
      />
    )
  },
  {
    value: null,
    label: <SelectLabel title="Don’t consider" />
  }
];

type Props = {
  importance?: number | null;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  disabled: boolean;
};

export const SelectImportance: FC<Props> = ({
  importance,
  onChange,
  disabled
}) => {
  return (
    <div className="flex items-center gap-2">
      <Select
        id="importance"
        // @ts-ignore
        options={importanceOptions}
        // @ts-ignore
        value={importance}
        className="w-[173px]"
        label="Importance"
        labelClassName="!text-content-300"
        onChange={onChange}
        isDisabled={disabled}
        searchable={false}
        hideOptional
      />
    </div>
  );
};
